
export default function StoreSection() {
  return (
    <section className="py-16 relative">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/f429614a618fd16a9c90b08965106012.jpg"
          alt="Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/30"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white/95 backdrop-blur-sm rounded-xl p-8 max-w-md">
          <h3 className="text-xl font-bold text-stone-900 mb-2">RECOGIDA EN TIENDA DISPONIBLE</h3>
          <p className="text-stone-600 text-sm mb-6 leading-relaxed">
            Calle Hermanos Villalonga 5, Bajo Derecha<br />
            46020, Valencia, España
          </p>
          <a
            href="https://maps.google.com?daddr=Calle+Hermanos+Villalonga+5+46020+Valencia+España"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-6 py-2.5 bg-stone-900 text-white font-medium text-sm hover:bg-stone-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            Obtener direcciones
          </a>
        </div>
      </div>
    </section>
  );
}
